import script from "./headerHome.vue?vue&type=script&setup=true&lang=js"
export * from "./headerHome.vue?vue&type=script&setup=true&lang=js"

import "./headerHome.vue?vue&type=style&index=0&id=cc6b016e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc6b016e"]])

export default __exports__